import React from 'react'
import popup from "~/views/Popup/popup";

import amexImg from "~/views/Popup/views/CreateSubscription/images/amex.png";
import discoverImg from "~/views/Popup/views/CreateSubscription/images/discover.png";
import mastercardImg from "~/views/Popup/views/CreateSubscription/images/mastercard.png";
import visaImg from "~/views/Popup/views/CreateSubscription/images/visa.png";

const paymentsMap = {
  amex: amexImg,
  discover: discoverImg,
  mastercard: mastercardImg,
  visa: visaImg
};

class TransactionInfo extends React.Component {
  render() {
    const { billingInfo = {} } = this.props.user
    const { stripeToken: { card: { brand, last4 } = {} } = {} } = billingInfo

    return (
      <section>
        <div className="title site-color">Transactions</div>
        <div className="clearfix"></div>
        <div className="detail">
          <div className="title site-color">Payment Processor</div>
          <div className="main">
            <span>
              { brand && <img
                alt="Payment"
                className="payment-card"
                src={paymentsMap[brand.toLowerCase()]}
                role="presentation" /> }
            </span>
            <span>
              { last4 ? ('**** **** **** ' + last4) : 'stripe' }
            </span>
          </div>
          <div className="buttons">
            <div
              className="button"
              onClick={ _ => popup.updateStripePayment() }>
              Update Billing
            </div>
            <div className="button" onClick={_ => popup.billingHistory()}>Billing History</div>
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
  }
}

export default TransactionInfo;